var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "hb-section",
    {
      attrs: {
        title: _vm.$t("influencer_panel.menu_campaigns"),
        subtitle: _vm.summary,
      },
      scopedSlots: _vm._u([
        {
          key: "actions",
          fn: function () {
            return [
              _c(
                "router-link",
                {
                  staticClass: "campaign-compact__all",
                  attrs: { to: { name: "influencer-panel-campaigns" } },
                },
                [
                  _vm._v(
                    " " + _vm._s(_vm.$t("influencer_panel.see_all")) + " "
                  ),
                  _c("feather-icon", {
                    attrs: { icon: "ChevronRightIcon", size: "14" },
                  }),
                ],
                1
              ),
            ]
          },
          proxy: true,
        },
      ]),
    },
    [
      !_vm.participations.length
        ? _c("hb-empty-state", {
            attrs: {
              title: _vm.$t("influencer_panel.no_campaigns"),
              icon: "TrendingUpIcon",
            },
          })
        : _c(
            "div",
            { staticClass: "campaign-compact__list" },
            _vm._l(_vm.participations, function (item) {
              return _c(
                "div",
                { key: item.id, staticClass: "campaign-compact__row" },
                [
                  _c("div", { staticClass: "campaign-compact__identity" }, [
                    _c("div", { staticClass: "campaign-compact__name" }, [
                      _vm._v(_vm._s(_vm.campaignName(item))),
                    ]),
                    _c("div", { staticClass: "campaign-compact__entity" }, [
                      _vm._v(_vm._s(_vm.entityLine(item))),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "campaign-compact__stat campaign-compact__stat--commission",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "campaign-compact__stat-label" },
                        [_vm._v(_vm._s(_vm.$t("influencer_panel.commission")))]
                      ),
                      _c(
                        "div",
                        { staticClass: "campaign-compact__stat-value" },
                        [_vm._v(_vm._s(_vm.commissionLabel(item)))]
                      ),
                    ]
                  ),
                  _c("div", { staticClass: "campaign-compact__stat" }, [
                    _c("div", { staticClass: "campaign-compact__stat-label" }, [
                      _vm._v(_vm._s(_vm.$t("influencer_panel.sales"))),
                    ]),
                    _c("div", { staticClass: "campaign-compact__stat-value" }, [
                      _vm._v(_vm._s(_vm.metric(item, "conversions"))),
                    ]),
                  ]),
                  _c(
                    "div",
                    {
                      staticClass:
                        "campaign-compact__stat campaign-compact__stat--earned",
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "campaign-compact__stat-label" },
                        [_vm._v(_vm._s(_vm.$t("influencer_panel.you_earned")))]
                      ),
                      _c(
                        "div",
                        { staticClass: "campaign-compact__stat-value" },
                        [
                          _c("hb-money", {
                            attrs: {
                              cents: _vm.metric(item, "commission_cents"),
                              tone: "brand",
                            },
                          }),
                        ],
                        1
                      ),
                    ]
                  ),
                  item.coupon_code
                    ? _c(
                        "div",
                        {
                          staticClass: "campaign-compact__coupon",
                          attrs: {
                            title: _vm.$t("influencer_panel.coupon_label"),
                          },
                        },
                        [
                          _c("feather-icon", {
                            attrs: { icon: "TagIcon", size: "13" },
                          }),
                          _c("code", [_vm._v(_vm._s(item.coupon_code))]),
                          _c("hb-copy-button", {
                            attrs: {
                              text: item.coupon_code,
                              "allow-share": false,
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _c(
                    "div",
                    { staticClass: "campaign-compact__badge" },
                    [
                      _vm.endingSoon(item)
                        ? _c(
                            "b-badge",
                            { attrs: { variant: "light-warning" } },
                            [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm.$t("influencer_panel.ends_in_days", {
                                      days: item.days_to_end,
                                    })
                                  ) +
                                  " "
                              ),
                            ]
                          )
                        : _c("hb-status-badge", {
                            attrs: {
                              status: item.status,
                              domain: "participation",
                            },
                          }),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    { staticClass: "campaign-compact__actions" },
                    [
                      _c("hb-icon-button", {
                        attrs: {
                          icon: "Link2Icon",
                          tone: "primary",
                          label: _vm.$t("influencer_panel.generate_link"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("generate-link", item)
                          },
                        },
                      }),
                      _c("hb-icon-button", {
                        attrs: {
                          icon: "ImageIcon",
                          tone: "warning",
                          label: _vm.$t("influencer_panel.material_title"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("material", item)
                          },
                        },
                      }),
                      _c("hb-icon-button", {
                        attrs: {
                          icon: "InfoIcon",
                          tone: "success",
                          label: _vm.$t("influencer_panel.info_title"),
                        },
                        on: {
                          click: function ($event) {
                            return _vm.$emit("info", item)
                          },
                        },
                      }),
                    ],
                    1
                  ),
                ]
              )
            }),
            0
          ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }